<template>

  <div class="container pt-4 pb-4">

    <div>

      <b-row align-v="center">

        <b-col lg="12">

          <div class="mt-4">

            <div class="mt-3">

              <label>
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Napisz prompt do zdjęcia:
              </label>

              <b-input-group>

                <b-form-input v-model="query" size="lg" ref="query" rows=10 placeholder="np. Opisz jak ma wyglądać okładka np. Stwórz okładkę 3D ebooka pt. [WSTAW TYTUŁ] Dodaj Autora [WSTAW AUTORA]" v-on:keyup.enter="generateFinish()"></b-form-input>

              </b-input-group>



              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  image
                </span> 
                Dodaj zdjęcie (opcjonalne)
              </label>

              <b-input-group>

                <b-form-file type="file" accept="image/*" @change="onFileChange" size="lg" ref="file" placeholder="Wybierz plik..." browse-text="Wybierz plik"></b-form-file>

              </b-input-group>


              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  image
                </span> 
                Dodaj zdjęcie (opcjonalne)
              </label>

              <b-input-group>

                <b-form-file type="file" accept="image/*" @change="onFileChange2" size="lg" ref="file2" placeholder="Wybierz plik..." browse-text="Wybierz plik"></b-form-file>

              </b-input-group>

            </div>

          </div>

        </b-col>

      </b-row>

      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">

        </b-col>

        <b-col lg="6">

          <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
            Generuj grafikę
          </b-button>

        </b-col>

      </b-row>

 
      <div class="mt-2" >

        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje grafikę <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Proszę czekać...</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" style="font-size: 1em;">

            <img ref="outputImg" style="width:100%;height:auto;" src="" />

          </blockquote>

        </b-card>

      </div>

    </div>

  </div>

</template>

<script>

export default {
  name: 'AppGraphicAi',
  components: {
  },
  data() {
    return {
      isFinish: false,
      result: "",
      generatedImg: false,
      imageBase64: null,
      imageBase64_2: null,
      selectedText: '',
      query: "",
      finishContent: '',
      selectedSchema: null
    }
  },
  methods: {

    onFileChange (event) {
      const file = event.target.files[0]
      if (!file) return

      const reader = new FileReader()

      reader.onload = (e) => {
        this.imageBase64 = e.target.result.split(',')[1]
        // albo jeśli chcesz tylko czysty base64:
        // this.imageBase64 = e.target.result.split(',')[1]
      }

      reader.readAsDataURL(file)
    },

    
    onFileChange2 (event) {
      const file = event.target.files[0]
      if (!file) return

      const reader = new FileReader()

      reader.onload = (e) => {
        this.imageBase64_2 = e.target.result.split(',')[1]
        // albo jeśli chcesz tylko czysty base64:
        // this.imageBase64 = e.target.result.split(',')[1]
      }

      reader.readAsDataURL(file)
    },

    generateFinish: function() {

      if(!this.query) return false;

      this.$refs.generatePost.disabled = true

      this.isFinish = true

      this.finishContent = ""
      this.result = ""

      
      this.axios.post(window.API_URL + "apps/graphicAi/paintnb/", { 'prompt': this.query, 'imageBase64': this.imageBase64, 'imageBase64_2': this.imageBase64_2 }, { withCredentials: true, timeout: 60000 }).then((response2) => {

          let data = response2.data

          this.finishContent = true;

          this.$refs.outputImg.src = "data:image/jpeg;charset=utf-8;base64," + data.base64;

          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana grafika"


        }).catch(function() {

          this.$refs.generatePost.disabled = false

        });



    }

  },
  computed: {

  },
  created() {

    this.$watch('finishContent', (value) => {

      var lines = value.split(/\r|\r\n|\n/);

      this.finishLinesCount = lines.length;

    })

  }

}
</script>

<style>

.pointer { cursor: pointer; }
.bold { font-weight: 600 !important; }
code { color: #4e82f7 !important; }
</style>